import { Heart } from "lucide-react";
import { IMAGES } from "../lib/content";
import { useSite } from "../context/SiteContext";
import { PageHero } from "../components/site/Layout";
import { Sparkle, StitchDivider } from "../components/site/Decor";
import { OrderCTA } from "../components/site/OrderCTA";

export default function About() {
  const { site } = useSite();
  const paras = site.about_story.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);
  return (
    <>
      <PageHero eyebrow="About us" title="Made with love," script="every stitch" testid="about-hero" />
      <section className="mx-auto grid max-w-7xl gap-14 px-6 py-20 lg:grid-cols-[1fr_1.1fr]">
        <div className="relative">
          <div className="gold-trim absolute -left-4 -top-4 h-full w-full rounded-[2rem]" />
          <img src={IMAGES.heroAlt} alt="Colorful embroidery thread" className="relative aspect-[4/5] w-full rounded-[2rem] object-cover" />
        </div>
        <div className="space-y-5 text-base leading-relaxed text-[#0E0B0D]/75 sm:text-lg" data-testid="about-story">
          <h2 className="font-display text-3xl font-bold text-[#0E0B0D] sm:text-4xl">Our story</h2>
          {paras.map((p, i) => <p key={i} className="whitespace-pre-line">{p}</p>)}
          <StitchDivider pink className="!my-10" />
          {site.about_thank_you && (
          <div className="stitch-box relative rounded-3xl bg-[#FFF4F8] p-8" data-testid="about-thank-you">
            <Sparkle className="absolute right-6 top-6" />
            <p className="font-script text-4xl text-[#FF1F8E]">Thank you</p>
            <p className="mt-2 whitespace-pre-line text-[#0E0B0D]/80">{site.about_thank_you}</p>
            <p className="mt-4 flex items-center gap-2 font-semibold text-[#0E0B0D]"><Heart className="h-4 w-4 fill-[#FF1F8E] text-[#FF1F8E]" /> KMK Customs</p>
          </div>
          )}
        </div>
      </section>
      <OrderCTA />
    </>
  );
}
